
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      // media query context
      const mm = this.$gsap.matchMedia(this.$refs.navHeader) // scope to navHeader only

      // executes desktop only - lg breakpoint
      mm.add('(min-width: 1024px)', () => {
        this.initAnimation()
      })
    })
  },
  methods: {
    initAnimation() {
      this.$gsap.set(['.forum-avatar', '.icon'], {
        opacity: 0,
        // scale: 0.8,
        y: 50,
      })

      this.$gsap
        .timeline()
        .from('#paint3_linear_2518_115592 stop', {
          attr: { offset: '0', stopColor: '#0000' },
          duration: 1.3,
        })
        .from(
          '.well-forum-graphic path',
          {
            drawSVG: 0,
            duration: 1.3,
            onComplete: () => {
              this.$gsap.to(['.forum-avatar', '.icon'], {
                opacity: 1,
                // scale: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.06,
              })

              const tweenProperty = (target, prop, min, max) => {
                const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
                const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

                this.$gsap.to(target, {
                  [prop]: this.$gsap.utils.random(min, max),
                  duration: randomDur(),
                  delay: randomDelay(),
                  ease: 'none',
                  onComplete: tweenProperty,
                  onCompleteParams: [target, prop, min, max],
                })
              }

              // Animate the properties individually
              this.$gsap.utils.toArray('.forum-avatar').forEach((star) => {
                // tweenProperty(star, "scale", 0.5, 4);
                tweenProperty(star, 'x', -12, 12)
                tweenProperty(star, 'y', -12, 12)
              })
            },
          },
          0
        )
    },
  },
}
